// src/pages/ActivityPage.js
import React, { useMemo } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { parseActivityId } from "../utils/results/parseActivityId";
import { useUserDoc } from "../hooks/useUserDoc";
import { useAuth } from "../context/AuthContext"; // NEW
import { useActivityData } from "../hooks/useActivityData";
import { useAccessControl } from "../hooks/useAccessControl";

import SpirometryActivityDetails from "../components/result/SpirometryActivityDetails";
import ExertionRecoveryActivityDetails from "../components/result/ExertionRecoveryActivityDetails";

export default function ActivityPage() {
  const { user } = useAuth(); // get auth user correctly
  const { data: userDoc } = useUserDoc(); // optional: profile info
  const location = useLocation();
  const navigate = useNavigate();
  const { lockResults } = useAccessControl();

  const baseName = useMemo(
    () => parseActivityId(location.search),
    [location.search]
  );

  const params = new URLSearchParams(location.search);
  const useExertionMock = params.get("exertionMock") === "1";
  const mockUid = "local-test";
  const mockBase = "debug-001";

  const uid = useExertionMock ? mockUid : user?.uid || null;
  const effectiveBaseName = useExertionMock ? mockBase : baseName;

  const tag = "breatheultra";

  const {
    loadingIndex,
    loadingBlob,
    loading,
    notFound,
    error,
    activity,
    data,
  } = useActivityData({
    uid,
    baseName: effectiveBaseName,
    tag,
    fetchBlob: false,
  });

  // If we genuinely have no uid or no id, bounce back
  if (!uid || !effectiveBaseName) {
    navigate("/home", { replace: true, state: { err: "invalid_activity" } });
    return null;
  }

  // Not found → bounce back once loading finished
  if (!loading && (notFound || !activity)) {
    navigate("/home", { replace: true, state: { err: "invalid_activity" } });
    return null;
  }

  // Skeleton while we fetch the index
  if (loadingIndex || !activity) {
    return (
      <div className="w-full max-w-lg p-4">
        <div className="animate-pulse h-8 w-40 rounded bg-muted mb-4" />
        <div className="animate-pulse h-24 w-full rounded bg-muted" />
      </div>
    );
  }

  const d =
    activity.date instanceof Date
      ? activity.date
      : new Date(activity.timestamp || Date.now());

  const preview =
    activity.kind === "spirometry" ? (
      <SpirometryActivityDetails
        uid={uid}
        baseName={effectiveBaseName}
        date={d}
        data={!loadingBlob && data ? data : null}
        locks={lockResults?.locks ?? {}}
      />
    ) : activity.kind === "exertion" ? (
      <ExertionRecoveryActivityDetails
        uid={uid}
        baseName={effectiveBaseName}
        date={d}
        data={!loadingBlob && data ? data : null}
        locks={lockResults?.locks ?? {}}
      />
    ) : null;

  return (
    <div className="relative w-full max-w-lg h-fit flex flex-col p-4 gap-4 z-10 mx-auto">
      {preview}
    </div>
  );
}
